// extracted by mini-css-extract-plugin
module.exports = {"bannerContainer":"styles_bannerContainer__2aNHG","bannerItem":"styles_bannerItem__zt858","itemText":"styles_itemText__27KuM","shopText":"styles_shopText__dUEz7"};